module.exports = __webpack_public_path__ + "img/e7bdd8a.jpg";